import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import FileInput from '../../../components/FileInput';
import MyModal from '../../../components/Modal';

interface ImportModalI {
  importModalShow: boolean;
  csvFileName: string;
  handleFileUpload: (event: ChangeEvent<HTMLInputElement>) => void;
  handleSubmitFile: () => Promise<void>;
  setImportModalShow: Dispatch<SetStateAction<boolean>>;
}

export default function ImportModal({
  importModalShow,
  csvFileName,
  handleFileUpload,
  handleSubmitFile,
  setImportModalShow,
}: ImportModalI) {
  return (
    <MyModal
      show={importModalShow}
      title="Importar locais por CSV"
      centeredBody
      modalBody={(
        <>
          <FileInput
            buttonLabel="Importar arquivo"
            fileNameChoosed={csvFileName}
            isSubmitButtonDisabled={!csvFileName}
            onFileUpload={handleFileUpload}
            onSubmitFile={handleSubmitFile}
            acceptedFiles=".csv"
          />
          <strong>ATENÇÃO: Essa ação irá INCLUIR os registros novos e ATUALIZAR os dados dos existentes, que são identificados conforme código. Os dados atualizados são: NOME, DESCRIÇÃO, ENDEREÇO, BAIRRO, CIDADE, UF e CEP. Portanto, não suba sempre a planilha inteira, pois todos os locais que tiverem na planilha terão os demais dados atualizados para o padrão, como configurações de distância, latitude e longitude, dados de fretamento, etc.</strong>
        </>
      )}
      closeButtonLabel="Fechar"
      onClose={() => setImportModalShow(false)}
      type="info"
    />
  );
}
